import { environment } from '@env/environment';

const MSAL_URL = environment.msalUrl;

let B2C_POLICY_SIGIN:string  ;
let B2C_AUTHORITY_SIGNIN : string;
if(window.location.href.includes('https://www.s3caceis.com.br/portal/')) {
     B2C_POLICY_SIGIN = 'B2C_1A_SIGNIN_MFA';
     B2C_AUTHORITY_SIGNIN='https://b2csantandercaceiscloud.b2clogin.com/b2csantandercaceiscloud.onmicrosoft.com/B2C_1A_SIGNIN_MFA'
}
else if(window.location.href.includes('https://s3portal-cer2.s3caceisinternal.com.br/')) {
        B2C_POLICY_SIGIN = 'B2C_1A_SIGNIN_MFA';
        B2C_AUTHORITY_SIGNIN='https://b2csantandercaceisclouddev.b2clogin.com/b2csantandercaceisclouddev.onmicrosoft.com/B2C_1A_SIGNIN_MFA'
}
else if (window.location.href.includes('https://s3portal-uat.s3caceisinternal.com.br/portal/')) {
    B2C_POLICY_SIGIN = 'B2C_1A_SIGNIN_MFA';
    B2C_AUTHORITY_SIGNIN = 'https://b2csantandercaceiscloudcer.b2clogin.com/b2csantandercaceiscloudcer.onmicrosoft.com/B2C_1A_SIGNIN_MFA';

}
else {
    B2C_POLICY_SIGIN ='B2C_1A_SIGNIN_MFA';

    B2C_AUTHORITY_SIGNIN = 'https://b2csantandercaceisclouddev.b2clogin.com/b2csantandercaceisclouddev.onmicrosoft.com/B2C_1A_SIGNIN_MFA';

}

const B2C_POLICY_PASSWORD_RESET = environment.b2cPolicyPasswordReset;
const B2C_AUTHORITY_PASSWORD_RESET = environment.b2cAuthorityPasswordReset;

const B2C_USER_INFO_SCOPE = environment.b2cUserInfoScope;
const B2C_WEB_API_SCOPE = environment.b2cWebApiScope;

const B2C_CLIENT_ID = environment.b2cClientId;
const B2C_AUTHORITY_DOMAIN = environment.b2cAuthorityDomain;

// this checks if the app is running on IE
export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

/** =================== REGIONS ====================
 * 1) B2C policies and user flows
 * 2) Web API configuration parameters
 * 3) Authentication configuration parameters
 * 4) MSAL-Angular specific configuration parameters
 * =================================================
*/

// #region 1) B2C policies and user flows
/**
 * Enter here the user flows and custom policies for your B2C application,
 * To learn more about user flows, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: `${B2C_POLICY_SIGIN}`,
        forgotPassword: `${B2C_POLICY_PASSWORD_RESET}`,
    },
    authorities: {
        signUpSignIn: {
            authority: `${B2C_AUTHORITY_SIGNIN}`
        },
        forgotPassword: {
            authority: `${B2C_AUTHORITY_PASSWORD_RESET}`
        }
    },
    authorityDomain: `${B2C_AUTHORITY_DOMAIN}`
}
// #endregion


// #region 2) Web API Configuration
/**
 * Enter here the coordinates of your Web API and scopes for access token request
 * The current application coordinates were pre-registered in a B2C tenant.
 */
export const apiConfig: {scopes: string[], uri: string} = {
    scopes: [
      `${B2C_USER_INFO_SCOPE}`
    ],
    uri: `${B2C_WEB_API_SCOPE}`
};
// #endregion
